import useCheckoutThreshold from '../order/useCheckoutThreshold';
import useDeliveryThreshold from '../order/useDeliveryThreshold';
import useOrderMethodsStatus from '../availability/useOrderMethodsStatus';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';

const useIsCheckoutDisabled = (): boolean => {
  const { hasReachedCheckoutThreshold } = useCheckoutThreshold();
  const { hasDeliveryThreshold, isWithinThreshold } = useDeliveryThreshold();
  const { isOrderMethodCurrentlyOpen, isOrderMethodOpenForFutureOrders } = useOrderMethodsStatus();
  const cachedOrder = useSelector((state: StoreInterface) => state.order.cached_order);

  return (
    !hasReachedCheckoutThreshold ||
    (hasDeliveryThreshold && !isWithinThreshold) ||
    (!isOrderMethodCurrentlyOpen(cachedOrder?.method) && !isOrderMethodOpenForFutureOrders(cachedOrder?.method))
  );
};

export default useIsCheckoutDisabled;
